import React, { useState } from "react";
import { styled } from "@mui/system";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import TopToolbar from "./TopToolbar";
import OHIFIframeViewer from "../shared/OHIFIframeViewer";
import { Routes, Route } from "react-router-dom";
import Home from "../../pages/Home";

const DrawerWidth = 0;
const ToolbarHeight = 64;

const ContentWrapper = styled("div")({
  display: "flex",
  flexDirection: "column",
  height: "100vh",
  overflow: "hidden",
});

const BodyWrapper = styled("div")({
  display: "flex",
  flexGrow: 1,
});

const MainContent = styled("main", {
  shouldForwardProp: (prop) => prop !== "open" && prop !== "isMobile",
})(({ theme, open, isMobile }) => ({
  flexGrow: 1,
  padding: "20px",
  marginLeft: isMobile ? 0 : DrawerWidth,
  marginTop: ToolbarHeight,
  transition: theme.transitions.create("margin", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    marginLeft: 0,
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

const DashboardLayout = ({ children }) => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [activeTab, setActiveTab] = useState("patients");
  const [selectedPatient, setSelectedPatient] = useState(null);
  const [iframeUrl, setIframeUrl] = useState(null);

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const isViewMode = activeTab === "view";

  const openIframeViewer = (url) => {
    setIframeUrl(url);
    setActiveTab("view");
  };

  return (
    <ContentWrapper>
      <TopToolbar
        handleDrawerToggle={handleDrawerToggle}
        activeTab={activeTab}
        setActiveTab={setActiveTab}
        selectedPatient={selectedPatient}
        setIframeUrl={setIframeUrl}
        openIframeViewer={openIframeViewer}
      />
      <BodyWrapper>
        <MainContent
          sx={{
            padding: "8px",
          }}
          open={!isMobile || mobileOpen}
          isMobile={isMobile}
        >
          {isViewMode ? (
            <OHIFIframeViewer
              url={iframeUrl}
              onClose={() => setActiveTab("patients")}
            />
          ) : (
            <Routes>
              <Route
                path="/"
                element={
                  <Home
                    selectedPatient={selectedPatient}
                    setSelectedPatient={setSelectedPatient}
                    setActiveTab={setActiveTab}
                    setIframeUrl={setIframeUrl}
                    openIframeViewer={openIframeViewer}
                  />
                }
              />
            </Routes>
          )}
        </MainContent>
      </BodyWrapper>
    </ContentWrapper>
  );
};

export default DashboardLayout;
